import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, UserCircle } from "lucide-react";
import Logo from "@/components/Logo";
import GmtClock from "@/components/GmtClock";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/services", label: "Services & Pricing" },
  { to: "/about", label: "Why RMS" },
  { to: "/blog", label: "The HR Insight" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-[#0A0F1D]/80 backdrop-blur-xl" data-testid="navbar">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="navbar-logo" aria-label="RMS Group home">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="navbar-links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-200 ${isActive ? "text-[#C5A059]" : "text-slate-300 hover:text-slate-50"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <GmtClock />
          <button
            data-testid="navbar-portal-btn"
            onClick={() => navigate(user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/auth")}
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-[#C5A059]"
          >
            <UserCircle size={18} />
            {user ? "My Portal" : "Client Portal"}
          </button>
          <Link to="/order" data-testid="navbar-order-btn" className="btn-gold !px-6 !py-2.5">
            Order Now
          </Link>
        </div>

        <button data-testid="navbar-mobile-toggle" className="text-slate-200 lg:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-800 bg-[#0A0F1D] px-5 py-6 lg:hidden" data-testid="navbar-mobile-menu">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-base font-medium text-slate-200">
                {l.label}
              </NavLink>
            ))}
            <NavLink to={user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/auth"} onClick={() => setOpen(false)} className="text-base font-medium text-slate-200">
              {user ? "My Portal" : "Client Portal"}
            </NavLink>
            <Link to="/order" onClick={() => setOpen(false)} className="btn-gold w-fit">
              Order Now
            </Link>
            <GmtClock />
          </div>
        </div>
      )}
    </header>
  );
}
